import { combineReducers } from "redux";
import reducer from "./reducer";

const rootReducer = combineReducers({
  allData: reducer,
});
export default rootReducer;
